import type { IconSvgObject } from './types';

const DigestionIcon: IconSvgObject = [
  ["path", { d: "M9.52409 2C9.52409 3.5 10.4772 4.57432 12.5037 3.87202C16.6908 2.42099 20 6.8491 20 10.8C20 15.0474 17.1832 18 13.0514 18C10.5279 18 7.5 19.5 7.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.0058 2V2.77557C6.0058 6.57844 11.4279 9.38737 9.63736 13.1999C8.92581 14.715 4 17.5 4 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 7C14.9576 7.29708 15.711 8.04937 16 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DigestionIcon;
